const Best = [
    { label: "0-100", value: "1" },
    { label: "100-200", value: "2" },
    { label: "200-300", value: "3" },
    { label: "300-400", value: "4" },
    { label: "400-500", value: "5" },
  ];
  
  export default Best;
  